import { useHistory, useParams } from "react-router";

import { LanguagesAbbr, ModuleMap, PageLinkType, PageModuleType } from "../../../types/working-model";
import { parseUrl } from "../../../utils/utils";
import { eventPath } from "../../live-event/utils";
import { Button } from "../button/button";
import { validate } from 'uuid';
import classNames from 'classnames';
import '../../../scss/live-event/base/general-ui/live-call-to-action.scss';
import { useTypedSelector } from "../../../store/reducers/use-typed-selector";
import { ParamsProps } from "../../live-event/live-event";

interface LiveCTAProps {
	classname: string;
	template: string;
	buttonText: string | string[];
	pageLink: PageLinkType | null;
	sectionLink: PageModuleType | null;
	urlLink: string | null;
	eventName: string | undefined;
	uuid: string | undefined;
	selectedLanguage: LanguagesAbbr;
	registration_on: boolean;
}

const LiveCallToAction: React.FC<LiveCTAProps> = ({
	classname,
	template,
	buttonText,
	pageLink,
	sectionLink,
	urlLink,
	uuid,
	selectedLanguage,
	registration_on
}) => {
	const history = useHistory();
	const { language, eventName } = useParams() as ParamsProps;

	const eventBundle = useTypedSelector(state => state.LiveEventReducer.eventBundle);
	const blProfileUser = useTypedSelector(state => state.LiveEventReducer.blProfileUser);

	// FUTURE DEV: ideally, this function will not be needed because localhost dev will not have an event name
	// current brandlive-dev.com is not pulling the event name from the params correctly, so we're forcing it through the props
	// This ensures that an event name is always present, nullifying the eventPath() function. Once resolved, remove this function,
	// and replace the getEventName() calls with eventPath() calls
	function getEventName() {
		return eventPath(eventName, uuid);
	}

	function getCustomPagePath(customPath: string) {
		return `/${eventPath(eventName, uuid)}/${language}/pages/${customPath}`;
	}

	const handleClick = () => {
		if (pageLink) {
			//Custom Page Links are stored as uuids
			if (validate(pageLink)) {
				const customPage = eventBundle?.custom_pages?.find(page => page.uuid === pageLink);
				if (customPage) {
					history.push(getCustomPagePath(customPage.path));
					return;
				}
			}
			switch (pageLink) {
				case PageLinkType.termsAndConditions: {
					history.push(`/${getEventName()}/${selectedLanguage}/terms-conditions`);
					return;
				}
				case PageLinkType.registration: {
					if (registration_on)
						history.push(`/${getEventName()}/${selectedLanguage}/registration`);
					else
						history.push(`/${getEventName()}/${selectedLanguage}/home`);
					return;
				}
				case PageLinkType.privacyPolicy: {
					history.push(`/${getEventName()}/${selectedLanguage}/privacy-policy`);
					return;
				}
				case PageLinkType.landing: {
					history.push(`/${getEventName()}/${selectedLanguage}/`);
					return;
				}
				case PageLinkType.homepage: {
					if (registration_on)
						history.push(`/${getEventName()}/${selectedLanguage}/registration`);
					else
						history.push(`/${getEventName()}/${selectedLanguage}/home`);
					return;
				}
				case PageLinkType.agenda: {
					if (registration_on && !blProfileUser)
						history.push(`/${getEventName()}/${selectedLanguage}/registration`);
					else
						history.push(`/${getEventName()}/${selectedLanguage}/sessions`);
					return;
				}
				default: return;
			}
		}
		if (sectionLink) {
			document.getElementById(`${ModuleMap[sectionLink]}`)?.scrollIntoView({ behavior: 'smooth' });
			return;
		}
	};

	// if no button text, do not show the button
	if (!buttonText) return null;
	return (
		<>
			{urlLink ? (
				<a
					href={parseUrl(urlLink)}
					className={
						classNames(
							'call-to-action-url',
							classname,
							template
						)
					}
				>
					{buttonText}
				</a>
			) : (
				<Button
					classButton={classname}
					template={template}
					onClick={handleClick}
				>{buttonText}</Button>
			)}
		</>

	);
};

export default LiveCallToAction;
